module.exports = __webpack_public_path__ + "img/background-login.3dfdf43b.svg";